<script lang="ts">
  import { Container } from "sveltestrap";
  import Footer from "../components/Footer.svelte";
  import PricingFree from "../components/pricing/PricingFree.svelte";
  import { mailAddress } from "../stores";
</script>

<Container>
  <h1>Pricing</h1>

  <!-- <p class="text-muted">Find out all of our pricing plans!</p> -->
  <p class="text-muted">
    We are currently developing our billing system. We require to have at least
    100 users to charge for this system, so, until we achieve this number, all
    of our services will be free of charge. Once we have developed a billing
    solution you'll be notify (but know that we will offer very low prices)
  </p>

  <PricingFree />

  <div class="faq-section">
    <h1>FAQ</h1>
    <h3>Do you offer self-hosted solution?</h3>
    <p class="text-muted">
      Yes! You can self-host an instance in your private servers!
      <a href="mailto:{$mailAddress}">contact us</a> to learn more!
    </p>
  </div>
</Container>
<Footer />

<style>
  h1 {
    font-family: Montserrat;
    font-style: normal;
    font-size: 52px;
    line-height: 76px;
    font-weight: bold;
    text-transform: capitalize;
    color: #2f2e34;
  }

  h3 {
    font-family: Montserrat;
    font-style: normal;
    line-height: 50px;
    font-weight: bold;
    color: #2f2e34;
  }

  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 184%;
  }
</style>
